import { Typography } from '@mui/material';

export default function RankingDetail({ ranking }) {
	return (
		<>
			{ranking?.position && ranking.label ? (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						border: '0px solid red',
					}}
				>
					<div style={{ border: '0px solid green', width: '35%' }}>
						<Typography
							sx={{
								color: 'white',
								textAlign: 'center',
								fontSize: '11px',
								fontWeight: '500',
								fontFamily: 'Montserrat',
								lineHeight: 'normal',
								backgroundColor: '#ff7733',
								padding: '4px 8px',
								letterSpacing: '-0.33px',
								borderRadius: '8px',
								width: 'fit-content',
							}}
						>
							MÁS VENDIDO
						</Typography>
					</div>
					<div style={{ border: '0px solid green', width: '65%' }}>
						{`${ranking.position}° en ${ranking.label}`}
					</div>
				</div>
			) : (
				'not listed'
			)}
		</>
	);
}
